import { styled } from '../stitches.config';

export const P = styled('p', {
  margin: '20px 0',
  lineHeight: '1.4',
});
